export const types = {
  SAVE_ACCOUNT_TO_STATE: 'saverbotAccount',
  SAVE_PROFILE_TO_STATE: 'profile',
  SAVE_SAVINGS_HISTORY_TO_STATE: 'savingsHistory',
  UPDATE_PORTAL_HEADER_DATA: 'portalHeaderData',
  UPDATE_USER: 'user',
};

export const {
  SAVE_ACCOUNT_TO_STATE,
  SAVE_PROFILE_TO_STATE,
  SAVE_SAVINGS_HISTORY_TO_STATE,
  UPDATE_PORTAL_HEADER_DATA,
  UPDATE_USER,
} = types;
